import React, { useState, useEffect, useRef } from 'react'
import { Link, withRouter, RouteProps } from 'react-router-dom'
import posed, { PoseGroup } from 'react-pose'

import styled from 'styled-components'

const Transition = posed.div({
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      default: {
        duration: 150,
      },
    },
  },
  exit: {
    y: 20,
    opacity: 0,
    transition: {
      duration: 100,
    },
  },
})

type Item = {
  href?: string
  title: string
  handler?: () => void
}

type Props = {
  align?: 'left' | 'right'
  items?: Item[]
  renderTrigger?: (props: any) => any
} & RouteProps

const Container = styled.div`
  position: relative;
  display: inline-block;
`

const Trigger = styled<any>('div')`
  border-radius: 4px;
  border: 1px solid;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  padding: 10px;
  user-select: none;
  transition: all 200ms;

  &:hover {
    background-color: rgb(93, 120, 255);
    border-color: rgb(93, 120, 255);
    color: #fff;
  }

  ${(props) =>
    props.open &&
    `
    background-color: rgb(93, 120, 255);
    border-color: rgb(93, 120, 255);
    color: #fff;
  `}
`

const Menu = styled<any>(Transition)`
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #eee;
  box-shadow: 0 0 13px 0 rgba(82, 63, 105, 0.1);
  left: 100%;
  min-width: 300px;
  overflow: hidden;
  position: absolute;
  top: -50px;
  z-index: 200;
`

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
`

const itemStlyes = `
  align-items: center;
  color: rgb(108, 114, 147);
  cursor: pointer;
  display: flex;
  height: 100%;
  padding: 0 20px;
  text-decoration: none;
  width: 100%;

  &:hover {
    background-color: #f5f5f5;
  }
`

const StyledLink = styled(Link)`
  ${itemStlyes}
`

const StyledButton = styled.a`
  ${itemStlyes}
`

const MenuItem: React.SFC<Item> = (props) => (
  <ItemContainer>
    {props.href ? (
      <StyledLink to={props.href}>{props.title}</StyledLink>
    ) : (
      <StyledButton onClick={props.handler}>{props.title}</StyledButton>
    )}
  </ItemContainer>
)

const Dropdown = withRouter((props: Props) => {
  const ref = useRef() as any

  const [open, setOpen] = useState(false)

  const onClick = () => {
    setOpen(!open)
  }

  const onOutsideClick = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', onOutsideClick)

    return () => {
      document.removeEventListener('mousedown', onOutsideClick)
    }
  }, [])

  useEffect(() => {
    setOpen(false)
  }, [props.location.pathname])

  return (
    <Container onClick={onOutsideClick} ref={ref}>
      {props.renderTrigger ? (
        props.renderTrigger({
          open,
          onClick,
        })
      ) : (
        <Trigger open={open} onClick={onClick}>
          Apps
        </Trigger>
      )}

      <PoseGroup>
        {open && (
          <Menu key="?" align={props.align}>
            {props.children}

            {props.items && (
              <>
                {props.items.map(({ href, title, handler }, index) => (
                  <MenuItem href={href} title={title} handler={handler} key={index} />
                ))}
              </>
            )}
          </Menu>
        )}
      </PoseGroup>
    </Container>
  )
}) as any

export { Dropdown }
